import React, { useEffect, useState } from 'react'
import { useI18N } from '../../libraries/i18n/hook'
import Markdown, { Components } from 'react-markdown'

// Import markdown files directly
import esMarkdown from '../../content/internal-offers-faqs/es.md?raw'
import enMarkdown from '../../content/internal-offers-faqs/en.md?raw'

const ExplanatoryPage: React.FC = () => {
  const { currentLanguage } = useI18N()
  const [markdown, setMarkdown] = useState('')

  useEffect(() => {
    try {
      // Use the imported markdown directly
      const content = currentLanguage === 'es' ? esMarkdown : enMarkdown
      setMarkdown(content)
    } catch (error) {
      console.error('Failed to load markdown content:', error)
      setMarkdown('Error: Content could not be loaded.')
    }
  }, [currentLanguage])

  const customRenderers: Partial<Components> = {
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    p: ({ node, ...props }) => <p className='text-md' {...props} />
  }

  return (
    <div className='prose lg:prose-xl max-w-none'>
      <Markdown components={customRenderers} className='whitespace-pre-wrap list-none text-3xs'>{markdown}</Markdown>
    </div>
  )
}

export default ExplanatoryPage
